export default {
  appId: "6996e111ce76b061f30e80c1",
  apiUrl: "https://api.bricodes.com",
  storageUrl: "https://storage.bricodes.com",
  sentryDsn: "https://b288b940c0e4c34c96233a8ab37324ee@o279982.ingest.us.sentry.io/4511490096496640",
  languageCode: "pl"
};
